"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable no-nested-ternary */

/* eslint-disable no-param-reassign */

var solaris_model_1 = __importDefault(require("solaris-model"));

var canvas_1 = require("canvas");

var moment_instance_1 = require("./moment-instance");

exports.moment = moment_instance_1.moment;
exports.overwriteOrdinalPlaceholder = moment_instance_1.overwriteOrdinalPlaceholder; // eslint-disable-next-line import/no-extraneous-dependencies

var BASE_URL = "https://planets-in-time-assets.now.sh/";
var originalMaxWidth = 2953;
var originalCenter = originalMaxWidth / 2;
var orbitStrokeMultiplier = 0.0015;
var relativeSizes = {
  sun: 500 / 2 / originalMaxWidth,
  mercury: 120 / 2 / originalMaxWidth,
  venus: 180 / 2 / originalMaxWidth,
  earth: 230 / 2 / originalMaxWidth,
  mars: 165 / 2 / originalMaxWidth,
  jupiter: 390 / 2 / originalMaxWidth,
  saturn: 420 / 2 / originalMaxWidth,
  uranus: 300 / 2 / originalMaxWidth,
  neptune: 240 / 2 / originalMaxWidth,
  pluto: 110 / 2 / originalMaxWidth
};
var relativeDistances = {
  sun: 0,
  mercury: 3320 / 2 - originalCenter * 0.99,
  venus: 3480 / 2 - originalCenter * 0.99,
  earth: 3700 / 2 - originalCenter * 0.99,
  mars: 3920 / 2 - originalCenter * 0.98,
  jupiter: 4210 / 2 - originalCenter * 0.97,
  saturn: 4620 / 2 - originalCenter * 0.97,
  uranus: 4970 / 2 - originalCenter * 0.96,
  neptune: 5270 / 2 - originalCenter * 0.9575,
  pluto: 5450 / 2 - originalCenter * 0.955
};

var loadImage = function loadImage(url) {
  return new Promise(function (res, rej) {
    if (typeof window !== "undefined") {
      var image_1 = new Image();
      image_1.src = url;
      image_1.addEventListener("load", function () {
        return res(image_1);
      });
      image_1.addEventListener("error", rej);
    } else {
      var image_2 = new canvas_1.Image();
      image_2.src = url;

      image_2.onload = function () {
        return res(image_2);
      };

      image_2.onerror = rej;
    }
  });
};

var system = new solaris_model_1.default();

var getPlanetPositionsFromDate = function getPlanetPositionsFromDate(date, height, width, planets) {
  system.setTime(moment_instance_1.moment(new Date(date)).format("YYYY-MM-DD"));
  var bodies = system.bodies;
  return planets.map(function (planetName) {
    var _a = bodies[planetName].position,
        x = _a[0],
        y = _a[1];
    var dim = Math.min(width, height);
    var distance = (dim - dim / 20) / 2 * relativeDistances[planetName] / originalCenter * (9 / (planets.length - 1));
    var angle = Math.atan2(y, x) || 0;
    var newX = Math.cos(angle) * distance;
    var newY = Math.sin(angle) * distance;
    return {
      x: width / 2 + newX,
      y: height / 2 + newY,
      distance: distance,
      planetName: planetName
    };
  });
};

var backgroundImagePromise = loadImage(BASE_URL + "background.png");
var planetsImagesPromise = Promise.all(Object.keys(relativeSizes).map(function (planetName) {
  return __awaiter(void 0, void 0, void 0, function () {
    var url, _a;

    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          url = "" + BASE_URL + planetName + ".png";
          _a = {};
          return [4
          /*yield*/
          , loadImage(url)];

        case 1:
          return [2
          /*return*/
          , (_a.image = _b.sent(), _a.planetName = planetName, _a)];
      }
    });
  });
})).then(function (positions) {
  return positions.reduce(function (cur, next) {
    var _a;

    return __assign(__assign({}, cur), (_a = {}, _a[next.planetName] = next.image, _a));
  }, {});
});

var renderOrdinalText = function renderOrdinalText(ctx, str, fontFamily, fontSize, x, y) {
  var keys = Object.keys(moment_instance_1.Ordinal);
  var ordinalKey = keys.find(function (key) {
    return str.includes("[" + key + "]");
  });

  if (!ordinalKey) {
    ctx.fillText(str, x, y);
  } else {
    var _a = str.split("[" + ordinalKey + "]"),
        firstBit = _a[0],
        lastBit = _a[1];

    ctx.font = fontSize + "px " + fontFamily;
    ctx.fillText(lastBit, x, y); // 5 is a magic number

    x -= ctx.measureText(lastBit).width - fontSize / 5;
    ctx.font = fontSize / 1.5 + "px " + fontFamily;
    ctx.fillText(ordinalKey, x, y - fontSize / 2);
    x -= ctx.measureText(ordinalKey).width;
    ctx.font = fontSize + "px " + fontFamily;
    ctx.fillText(firstBit, x, y);
  }
};

var writeImageToCanvas = function writeImageToCanvas(date, canvas, includePluto, _a, dateFormat, showOrbitLines, font, shouldIncludeWatermark) {
  var lineOne = _a[0],
      lineTwo = _a[1];
  return __awaiter(void 0, void 0, void 0, function () {
    var planets, backgroundImage, canvasSize, ctx, images, planetPositions, BORDER_INSET, TEXT_INSET, BOTTOM_FONT_SIZE, TEXT_X, TEXT_TOP_Y, TEXT_BOTTOM_Y, watermarkFontSize;
    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          planets = ["sun", "mercury", "venus", "earth", "mars", "jupiter", "saturn", "uranus", "neptune"];

          if (includePluto) {
            planets = __spreadArrays(planets, ["pluto"]);
          }

          return [4
          /*yield*/
          , backgroundImagePromise];

        case 1:
          backgroundImage = _b.sent();
          canvasSize = backgroundImage.naturalWidth; // eslint-disable-next-line no-param-reassign

          canvas.height = canvasSize; // eslint-disable-next-line no-param-reassign

          canvas.width = canvasSize;
          ctx = canvas.getContext("2d");
          ctx.fillStyle = "transparent";
          return [4
          /*yield*/
          , planetsImagesPromise];

        case 2:
          images = _b.sent();
          planetPositions = getPlanetPositionsFromDate(date, canvasSize, canvasSize, planets).map(function (planet) {
            return __assign(__assign({}, planet), {
              image: images[planet.planetName]
            });
          });
          BORDER_INSET = canvasSize * 0.02;
          ctx.clearRect(0, 0, canvasSize, canvasSize);
          ctx.fillRect(0, 0, canvasSize, canvasSize);
          ctx.drawImage(backgroundImage, 0, 0, canvasSize, canvasSize);
          planetPositions.forEach(function (_a) {
            var x = _a.x,
                y = _a.y,
                planetName = _a.planetName,
                distance = _a.distance,
                image = _a.image;
            var imageSize = canvasSize * relativeSizes[planetName];

            if (showOrbitLines) {
              ctx.beginPath();
              ctx.arc(canvasSize / 2, canvasSize / 2, distance, 0, 2 * Math.PI);
              ctx.strokeStyle = "#F5F5F540";
              ctx.lineWidth = orbitStrokeMultiplier * canvasSize;
              ctx.stroke();
            }

            ctx.drawImage(image, x - imageSize / 2, y - imageSize / 2, imageSize, imageSize);
          });
          TEXT_INSET = BORDER_INSET / 2;
          BOTTOM_FONT_SIZE = canvasSize / 45;
          TEXT_X = BORDER_INSET + TEXT_INSET;
          TEXT_TOP_Y = canvasSize - BOTTOM_FONT_SIZE - BORDER_INSET - TEXT_INSET;
          TEXT_BOTTOM_Y = canvasSize - BORDER_INSET - TEXT_INSET;
          ctx.font = BOTTOM_FONT_SIZE + "px " + font;
          ctx.fillStyle = "white";
          ctx.textAlign = "right";
          renderOrdinalText(ctx, moment_instance_1.moment(new Date(date)).format(dateFormat), font, BOTTOM_FONT_SIZE, canvasSize - TEXT_X, TEXT_TOP_Y);
          ctx.fillText("Planets In Time", canvasSize - TEXT_X, TEXT_BOTTOM_Y);
          ctx.textAlign = "left";
          if (lineOne) ctx.fillText(lineOne, TEXT_X, TEXT_TOP_Y);
          if (lineTwo) ctx.fillText(lineTwo, TEXT_X, TEXT_BOTTOM_Y); // Watermark

          if (shouldIncludeWatermark !== false) {
            watermarkFontSize = canvasSize / 5;
            ctx.fillStyle = "rgba(255, 255, 255, 0.3)";
            ctx.font = watermarkFontSize + "px " + font;
            ctx.textAlign = "center";
            ctx.fillText("PREVIEW", canvasSize / 2, canvasSize / 2 + watermarkFontSize / 3);
          }

          return [2
          /*return*/
          , canvas];
      }
    });
  });
};

exports.writeImageToCanvas = writeImageToCanvas;